export default "__VITE_ASSET__CnPItYR6__"